import React from "react";
import { Box, useTheme } from "@mui/material";
import {
  RiCheckboxCircleLine,
  RiIndeterminateCircleLine,
} from "@remixicon/react";

interface TableCellBooleanIconProps {
  value: boolean;
}

const TableCellBooleanIcon: React.FC<TableCellBooleanIconProps> = ({
  value,
}) => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" height="100%">
      {value ? (
        <RiCheckboxCircleLine size={18} color={theme.palette.success.light} />
      ) : (
        <RiIndeterminateCircleLine size={18} color={theme.palette.grey[500]} />
      )}
    </Box>
  );
};

export default TableCellBooleanIcon;
